"use client";
import React, { useState } from "react";
import parse from "html-react-parser";
import ArticlePill from "@/components/ContributorDetails/components/ArticlePill";
import QualificationsSummary from "@/components/ContributorDetails/components/QualificationsSummary";
import { ArticleData } from "@/types/Contributor";
import formatTextWithLink from "@/utils/functions/formatTextWithLink";
import useTranslations from "@/i18n/useTranslations";
interface ContributorDetailProps {
  expertise: string;
  education: string;
  accomplishments: string;
  about: string;
  articleData?: ArticleData[];
  website?: string;
  linkedin?: string;
}

export default function ContributorDetails({
  expertise,
  education,
  accomplishments,
  about,
  articleData,
  linkedin,
  website,
}: ContributorDetailProps) {
  const t = useTranslations("Contributor");
  const tCommon = useTranslations("Common");
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const pageCount = articleData
    ? Math.ceil(articleData.length / itemsPerPage)
    : 0;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = articleData?.slice(startIndex, endIndex);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };
  const baseGridClass = "grid grid-cols-1 md:grid-cols-2 gap-4";
  const baseLinkClass =
    "p-4 hover:text-white hover:shadow-lg hover:bg-secondary-500 no-underline hover:no-underline rounded-[4px]";
  return (
    <div className="container max-w-[950px] py-4">
      <div className="flex flex-col justify-center items-stretch md:flex-row gap-6">
        <div className="md:basis-1/4 overflow-auto">
          <QualificationsSummary
            expertise={expertise}
            education={education}
            accomplishments={accomplishments}
            linkedin={linkedin}
            website={website}
          />
        </div>
        <div className="md:basis-3/4">
          <h2 className="mt-0 text-2xl">{tCommon("aboutMe")}</h2>
          {about && parse(formatTextWithLink(about))}
          {articleData && articleData[0] && (
            <h2 className="text-2xl">{t("myLatestArticles")}</h2>
          )}
          <div className={baseGridClass}>
            {currentItems &&
              currentItems?.map((article) => (
                <ArticlePill
                  key={article.title}
                  link={article.uri}
                  heading={article.title}
                  publishDate={article.date}
                />
              ))}
          </div>
          {pageCount > 1 && (
            <div className="justify-center w-full text-center py-4">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={baseLinkClass}
              >
                &lt;
              </button>
              {Array.from({ length: pageCount }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    className={baseLinkClass}
                  >
                    {page}
                  </button>
                ),
              )}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === pageCount}
                className={baseLinkClass}
              >
                &gt;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
